module.exports = __webpack_public_path__ + "static/media/remarkable.e16f9f5b.png";